export default __webpack_public_path__ + "static/img/collections-knitwear-bg.0c33ba1.jpg";